module.exports = __webpack_public_path__ + "static/trademark_nginr-627a1c36d8e9471d48aa31cfe33b534f.png";